import React from 'react';
import SponsorsCarusel from '../../../components/Carusel/Carusel.jsx'
import getFileData, { fetchPublicDataFile } from "../../../APICall/Api.jsx";

import Loading from "../../../components/Loading/Loading.jsx";

class SectionSponsors extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      error: null,
      isLoaded: false,
      items: [],
      url: getFileData,
      title: this.props.title
    };
  }

  callAPI = () => {
    fetchPublicDataFile('Sponsors.json')
      .then(
        (result) => {
          this.setState({
            isLoaded: true,
            items: result.sponsors
          });
        },
        (error) => {
          this.setState({
            isLoaded: true,
            error: error
          });
        }
      )
  }

  componentDidMount() {
    this.callAPI()
  }

  componentWillReceiveProps(newProps) {
    this.setState({
      title: newProps.title
    })
  }

  render() {
    if (this.state.error) {
      return <div>Error: {this.state.error.message}</div>;
    } else if (!this.state.isLoaded) {
      return <Loading />;
    } else {
      return (
        <section className="bgg-section bgg-section-white bgg-sponsors-section">
          <div className="bgg-container">
            <div className="bgg-section-header">
              <h2 className="bgg-section-title">{this.state.title}</h2>
            </div>
          </div>
          <SponsorsCarusel imgs={this.state.items} />
        </section>
      );
    }
  }
}
export default SectionSponsors;



// WEBPACK FOOTER //
// ./src/views/Components/Sections/SectionSponsors.jsx